const styles = () => ({
    containerForm: {
        position: 'relative',
        paddingBottom: '130px',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    finalizeContainer: {
        position: 'absolute',
        right: '-1.13em',
        width: 'calc(100% + 4em)',
        bottom: '-1.2em',
        backgroundColor: '#e9e9e9',
        justifyContent: 'flex-end',
        padding: '20px',
    },
    finalizeBtn: {
        borderRadius: '25px',
        paddingRight: '20px',
        paddingLeft: '20px',
        height: '50px',
    },
    colorWhite: {
        color: '#fff',
    },
    loading: {
        margin: '0',
    },
    containerMainData: {
        marginTop: '10px',
    },
});

export default styles;
